export enum ESufficentSelections {
    NoSelector = 0,
    Distinct = 1 << 0,
    Body = 1 << 1,
    Doors = 1 << 2,
    EngineArrgmnt = 1 << 3,
    DriveLayout = 1 << 4,
    NAT = 1 << 5,
}
